/** Require hover intent so crossing a cluster row does not immediately focus its polygon. */
export const scheduleRiskPictureClusterPreview = (preview: () => void): (() => void) => {
  const timeout = setTimeout(preview, 180);
  return () => clearTimeout(timeout);
};
